import {Context} from "koa";
import {Core} from "@strapi/strapi";
import {TelegramLinkServiceType} from "../services/content-type/telegram-link";

export default (config: any, {strapi}: { strapi: Core.Strapi }) => {
  return async (ctx: Context, next) => {
    const initData = ctx.request.headers['x-telegram-init-data'] as string;

    try {
      const {validData, validTime, params} = strapi
        .plugin('telegram-bot')
        .service<TelegramLinkServiceType>('telegram-link')
        .validateInitData(initData);

      // Invalid token
      if (!validData) {
        return ctx.unauthorized('Invalid Telegram Info');
      }

      // Token expired
      if (!validTime) {
        return ctx.unauthorized('Token expired');
      }

      // Set telegramInfo to ctx
      ctx.telegramInfo = params;
    } catch (e) {
      return ctx.unauthorized('Unable to validate Telegram Info');
    }


    return next();
  };
}
